import Chartkick from "chartkick";
window.Chartkick = Chartkick;

import "chartkick/chart.js"

import { Chart } from "chart.js"
import annotationPlugin from "chartjs-plugin-annotation"

Chart.register(annotationPlugin)
